.scry-card {
  font-family: 'Crimson Pro', Georgia, serif;
  background: var(--scry-surface);
  border: 1px solid var(--scry-border);
  border-radius: 8px;
  padding: 20px;
  color: var(--scry-text);
  max-width: 380px;
  width: 100%;
}

.scry-card * {
  box-sizing: border-box;
}

.scry-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.scry-card-header:hover .scry-card-name {
  color: var(--scry-primary);
}

.scry-card-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid var(--scry-border);
  object-fit: cover;
  flex-shrink: 0;
}

.scry-card-avatar-placeholder {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid var(--scry-border);
  flex-shrink: 0;
  overflow: hidden;
}

.scry-card-name {
  font-family: 'Cinzel', serif;
  font-size: 18px;
  font-weight: 700;
  color: var(--scry-heading);
  line-height: 1.2;
}

.scry-card-address {
  font-family: 'Share Tech Mono', monospace;
  font-size: 11px;
  color: var(--scry-text-muted);
  margin-top: 2px;
  word-break: break-all;
}

.scry-card-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 16px;
}

.scry-card-stat {
  text-align: center;
  padding: 8px 4px;
  background: var(--scry-surface-deep);
  border-radius: 4px;
}

.scry-card-stat-value {
  font-family: 'Cinzel', serif;
  font-size: 20px;
  font-weight: 700;
  color: var(--scry-heading);
  display: block;
}

.scry-card-stat-label {
  font-family: 'Share Tech Mono', monospace;
  font-size: 10px;
  color: var(--scry-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.scry-card-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 16px;
}

.scry-card-badge {
  font-family: 'Share Tech Mono', monospace;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 3px;
  border: 1px solid;
}

.scry-card-badge--verified {
  color: var(--scry-success);
  border-color: var(--scry-success);
}

.scry-card-badge--unverified {
  color: var(--scry-text-muted);
  border-color: var(--scry-border);
}

.scry-card-link {
  display: block;
  text-align: right;
  font-size: 12px;
  color: var(--scry-text-muted);
  text-decoration: none;
}

.scry-card-link:hover {
  color: var(--scry-primary);
}

.scry-card-loading {
  text-align: center;
  padding: 24px;
  color: var(--scry-text-muted);
  font-size: 14px;
}
